<script setup lang="ts">
defineProps<{
  category: any
  lazy: boolean
}>()
</script>

<template>
  <article
    v-if="category?.PageUrl?.url"
    class="blog-category"
  >
    <div class="blog-category__content">
      <h2 class="blog-category__heading">
        <AppLink
          :to="`/${category.PageUrl.url}/`"
          class="blog-category__link"
        >
          {{ category.PageTitle || $t('Read more') }}
        </AppLink>
      </h2>
    </div>

    <div class="blog-category__visual">
      <picture v-if="category?.Image?.url">
        <source
          :srcset="useXcdnImage(category.Image.url, 'f=rs:fit:500')"
          media="(min-width: 1024px)"
        >
        <source
          :srcset="useXcdnImage(category.Image.url, 'f=rs:fit:750')"
          media="(min-width: 768px)"
        >
        <source
          :srcset="useXcdnImage(category.Image.url, 'f=rs:fit:500')"
        >
        <img
          v-if="category?.Image?.url"
          :src="useXcdnImage(category.Image.url, 'f=rs:fit:500')"
          :width="category?.Image?.width"
          :height="category?.Image?.height"
          :alt="category?.Image?.alternativeText || category?.PageTitle"
          class="blog-category__image"
          :loading="lazy ? 'lazy' : 'eager'"
          :fetchpriority="lazy ? 'low' : 'high'"
          :decoding="lazy ? 'async' : 'sync'"
        >
      </picture>
    </div>
  </article>
</template>

<style>
@import url("~layers/app/components/Blog/Category.css");
</style>
